import React, { useRef } from 'react';
import { getRsvpUnitAriaDetailsForMailListRow } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { getTimestamp, now } from 'owa-datetime';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { ListViewRsvpUnit } from 'mini-mail-list-rsvp-view';
import { ListViewSuggestedUnsubscribeUnit } from 'mini-mail-list-suggested-unsubscribe-view';
import type { ListViewRsvpUnitProps } from 'mini-mail-list-rsvp-view';
import type { MailListItemContainerProps } from '../../schema/MailListItemContainer.types';
import type { RichContents } from 'mini-mail-list-item/lib/schema/RichContents';

export type GetRichContentsProps = MailListItemContainerProps;

export const getRichContents = (props: GetRichContentsProps): RichContents => {
    const {
        rowId,
        appliedRichContentFlags = { showRSVPUnit: false, showSuggestedUnsubscribeUnit: false },
    } = props;
    const { showRSVPUnit = false, showSuggestedUnsubscribeUnit = false } = appliedRichContentFlags;
    const richContents: RichContents = {
        RSVPUnit: {
            Component: showRSVPUnit ? <ListViewRsvpUnitWrapper mailListRowId={rowId} /> : null,
            ariaDetails: getRsvpUnitAriaDetailsForMailListRow(rowId),
        },
        SuggestedUnsubscribeUnit: {
            Component:
                isMiniFeatureEnabled('mini-suggested-unsubscribe') &&
                isMiniHostAppFeatureEnabled('suggestedUnsubscribe') &&
                showSuggestedUnsubscribeUnit ? (
                    <ListViewSuggestedUnsubscribeUnit mailListRowId={rowId} />
                ) : null,
        },
    };
    return richContents;
};

const ListViewRsvpUnitWrapper = (props: ListViewRsvpUnitProps) => {
    const initialRenderTimestamp = useRef<number>(getTimestamp(now()));
    return <ListViewRsvpUnit {...props} initialRenderTimestamp={initialRenderTimestamp} />;
};
